import React from "react";
import useMeasure from "~/hooks/useMeasure";
import * as S from "./styles";

interface AnimateHeightProps {
  open: boolean;
  defaultHeight?: number;
  transitionOpacity?: boolean;
  children: React.ReactNode;
}

const AnimateHeight: React.FC<AnimateHeightProps> = ({
  transitionOpacity = true,
  defaultHeight = 0,
  open,
  children,
}) => {
  const [ref, rect] = useMeasure<HTMLDivElement>();

  const variants = {
    open: {
      height: rect.height,
      opacity: 1,
    },
    closed: {
      height: defaultHeight,
      opacity: transitionOpacity ? 0 : 1,
    },
  };

  return (
    <S.AnimateHeight
      variants={variants}
      initial={open ? "open" : "closed"}
      animate={open ? "open" : "closed"}
      transition={{
        ease: "easeInOut",
      }}
    >
      <div ref={ref}>{children}</div>
    </S.AnimateHeight>
  );
};

export default AnimateHeight;
